/**
 * This file is necessary to ensure that tests run properly, as otherwise
 * errors can come up from plugins (such as composition-api) not being properly
 * registered in Vue when used in the tests
 */
import Vue from 'vue';
import { applyPlugins } from '@front-app/plugins';

applyPlugins(Vue);

export default Vue;
